import { GeoPoint, geoPointSerialzier, Uuid, uuidSerializer } from "@legacy-megarax/common";
import { MSerializers } from "@legacy-megarax/serializers";

import { Travel, travelSerializer } from "./travel";

export type DayDto = {
  date: Date;
  userId: number;

  startTime: Date;
  homeLocation: GeoPoint;

  visits: ScheduleVisitDto[];
  travelHomeStart: Date;
  travelHome: Travel;
  totalTravel: Travel;
  totalDurationSeconds: number;

  removedVisits: RemovedVisitDto[];
};

export type RemovedVisitDto = {
  uuid: Uuid;
  customerUuid: Uuid;
};

export type ScheduleVisitDto = {
  uuid: Uuid;
  customerUuid: Uuid;
  startTime: Date;
  travelToVisit: Travel;
  durationMinutes: number;
  location: GeoPoint;
};

export const scheduleVisitDtoSerializer = MSerializers.object<ScheduleVisitDto>({
  uuid: uuidSerializer,
  customerUuid: uuidSerializer,
  durationMinutes: MSerializers.integer,
  location: geoPointSerialzier,
  startTime: MSerializers.datetime,
  travelToVisit: travelSerializer,
});

export const dayDtoSerializer = MSerializers.object<DayDto>({
  date: MSerializers.dateOnly,
  homeLocation: geoPointSerialzier,
  startTime: MSerializers.datetime,
  userId: MSerializers.integer,
  visits: MSerializers.array(scheduleVisitDtoSerializer),
  travelHome: travelSerializer,
  totalTravel: travelSerializer,
  travelHomeStart: MSerializers.datetime,
  totalDurationSeconds: MSerializers.integer,
  removedVisits: MSerializers.array(
    MSerializers.object<RemovedVisitDto>({
      uuid: uuidSerializer,
      customerUuid: uuidSerializer,
    }),
  ),
});
